import Gallery from './Components/Gallery.svelte';
const target = document.getElementById('gallery');
const gallery = new Gallery({target});
export default gallery;